export default __webpack_public_path__ + "static/media/kitchen3-before3-2048w.4033dadc.avif";